export const isPartner = () => window.partner || window.location.pathname.indexOf("/router/") >= 0;
export const isNonPartner = () => !isPartner();
export const partnerType = () => (isPartner() ? window.partner || window.location.pathname.split("/")[1] : "");
